import { render, staticRenderFns } from "./ClassBtn.vue?vue&type=template&id=caf444be&scoped=true"
import script from "./ClassBtn.vue?vue&type=script&lang=js"
export * from "./ClassBtn.vue?vue&type=script&lang=js"
import style0 from "./ClassBtn.vue?vue&type=style&index=0&id=caf444be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf444be",
  null
  
)

export default component.exports